//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { required, email } from 'vuelidate/lib/validators'

const CREATE_USER = gql`
  mutation ($data: UserCreateInput) {
    createUser(data: $data) {
      id
      email
    }
  }
`

const DATA_QUERY = gql`
  query {
    jobFunctions(first: 100, order: [{ name: ASC }]) {
      nodes {
        id
        name
      }
    }
  }
`

export default {
  name: 'RegistrationForm',
  props: {
    isInline: {
      type: Boolean,
      default: true
    },
    isSpaced: {
      type: Boolean,
      default: false
    },
    isShowCart: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default() {
        return this.$t('register.header')
      }
    },
    subheader: {
      type: String,
      default() {
        return this.$t('register.sub_header')
      }
    },
    showSubscription: {
      type: Boolean,
      default: true
    },
    registerAndCheckout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      latestArticle: null,
      jobFunctions: [],
      register: {
        email: null,
        password: null,
        sendOffer: true,
        firstName: null,
        lastName: null,
        company: null,
        jobFunction: null
      },
      error: null,
      loading: false,
      submitted: false,
      success: false
    }
  },
  validations: {
    register: {
      email: { required, email },
      password: { required },
      company: {},
      jobFunction: {},
      sendOffer: {},
      firstName: { required },
      lastName: { required }
    }
  },
  async fetch() {
    this.loading = true

    try {
      const { data } = await this.$apollo.query({
        query: DATA_QUERY
      })

      this.jobFunctions = data.jobFunctions.nodes
    } catch (error) {
      this.handleError(error)
    }

    this.loading = false
  },
  computed: {
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    cartItems() {
      return this.$store.get('cart/items') || null
    },
    cartTotal() {
      return this.cartItems.map((x) => x.quantity).reduce((a, b) => a + b, 0)
    }
  },
  mounted() {
    this.clear()
  },
  methods: {
    async onRegisterSubmit() {
      this.submitted = true

      this.$v.register.$touch()
      if (this.$v.register.$invalid) {
        this.$nextTick(() => {
          const el = document.querySelector('#registration-form input.is-danger')
          if (el) el.focus()
        })
        return false
      }

      try {
        this.loading = true
        const { data } = await this.$apollo.mutate({
          mutation: CREATE_USER,
          variables: {
            data: {
              email: this.register.email,
              password: this.register.password,
              isSendOffer: this.register.sendOffer,
              firstName: this.register.firstName,
              lastName: this.register.lastName,
              company: this.register.company,
              jobFunctionId: this.register.jobFunction
            }
          }
        })
        this.success = true

        this.$emit('userRegistered', { email: data.createUser.email, password: this.register.password })
      } catch (error) {
        this.error = this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    async onProviderSignIn(provider) {
      try {
        this.loading = true

        await this.$auth.login(provider, {
          locale: this.$store.get('language/locale') || 'en'
        })

        this.$emit('userLoggedIn')
      } catch (error) {
        this.error = this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    clear() {
      this.register = {
        email: null,
        password: null,
        jobFunction: null,
        company: null,
        sendOffer: false,
        firstName: null,
        lastName: null
      }
      this.error = null
      this.loading = false
      this.submitted = false
      this.success = false
    },
    onOpenCart() {
      this.$emit('close')
      this.openCart(true)
    }
  }
}
